import {Injectable, Injector} from '@angular/core';
import {BehaviorSubject, catchError, Observable, throwError, timeout} from 'rxjs';
import {InfoPantallaDTO} from '../dto/util/infoPantallaDTO';
import {driver} from 'driver.js';
import {AlertaModalService} from './util/alerta-modal.service';
import {CookieService} from 'ngx-cookie-service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {FooterInfoResponseDTO} from '../dto/util/footerInfoDTO';
import { Constants } from '../constants/constants';
import {environment} from '../../environments/environment';
import {TranslateService} from "@ngx-translate/core";
import {DatosAdicionalesService} from "../modules/util/modal-datos/services/datos-adicionales.service";
import { PreguntaDTO } from '../dto/encuesta/preguntas.dto';
import { EncuestaDTO } from '../dto/encuesta/encuesta.dto';

@Injectable({
  providedIn: 'root',
})
export class UtilService {
  // Multilenguaje
  guiaText: any = {};
  private translateService!: TranslateService;
  private datosAdicionalesService!: DatosAdicionalesService;

  private preguntaSeleccionada: PreguntaDTO | null = null;
  private preguntaIndex: number | null = null;
  private encuestaSeleccionada: EncuestaDTO | null = null;

  constructor(
    private http: HttpClient,
    private cookieService: CookieService,
    private alertaModalService: AlertaModalService,
    private injector: Injector // Inyecta el Injector
  ) {}
  private get translate(): TranslateService {
    if (!this.translateService) {
      this.translateService = this.injector.get(TranslateService);
    }
    return this.translateService;
  }

  // private get datosAdcionales(): DatosAdicionalesService {
  //   if (!this.datosAdicionalesService) {
  //     this.datosAdicionalesService = this.injector.get(DatosAdicionalesService);
  //   }
  //   return this.datosAdicionalesService;
  // }
  private apiUrl = environment.apiUrl;
  public showComponents: BehaviorSubject<boolean> =
    new BehaviorSubject<boolean>(true);
  public showNavUserComponent: BehaviorSubject<boolean> =
    new BehaviorSubject<boolean>(false);
  public idEntidad: BehaviorSubject<number> = new BehaviorSubject<number>(0);
  public timer!: ReturnType<typeof setTimeout>;
  // Guía interactiva e información de las pantallas
  public infoPantalla: BehaviorSubject<InfoPantallaDTO> =
    new BehaviorSubject<InfoPantallaDTO>({
      descripcionPantalla: '',
      pasos: [],
      tituloPantalla: '',
    });

  private statusSubject = new BehaviorSubject<string>('');
  public status$ = this.statusSubject.asObservable();

  public watch = (): Observable<boolean> => this.showComponents.asObservable();
  public hide = (): void => this.showComponents.next(false);
  public show = (): void => this.showComponents.next(true);

  public setStatus(status: string): void {
    this.statusSubject.next(status);
  }

  public getStatus(): string {
    return this.statusSubject.getValue();
  }

  public setPregunta(pregunta: PreguntaDTO | null): void {
    this.preguntaSeleccionada = pregunta;
  }

  public getPregunta(): PreguntaDTO | null {
    return this.preguntaSeleccionada;
  }

  public setIndexPregunta(index: number | null): void {
    this.preguntaIndex = index;
  }

  public getIndexPregunta(): number | null {
    return this.preguntaIndex;
  }

  public setEncuesta(encuesta: EncuestaDTO | null): void {
    this.encuestaSeleccionada = encuesta;
  }

  public getEncuesta(): EncuestaDTO | null {
    return this.encuestaSeleccionada;
  }

  // Funciones para infoPantalla
  public watchInfoPantalla = (): Observable<InfoPantallaDTO> =>
    this.infoPantalla.asObservable();
  public changeInfoPantalla = (nuevaInfoPantalla: InfoPantallaDTO): void =>
    this.infoPantalla.next(nuevaInfoPantalla);
  public watchNavUser = (): Observable<boolean> =>
    this.showNavUserComponent.asObservable();
  public hideNavUser = (): void => this.showNavUserComponent.next(false);
  public showNavUser = (): void => this.showNavUserComponent.next(true);

  public watchIdEntidad = (): Observable<number> =>
    this.idEntidad.asObservable();
  public setIdEntidad = (id: number): void => this.idEntidad.next(id);

  public iniciarGuiaInteractiva(onFinish?: () => void) {
    // Multilenguaje
    this.translate.stream('guias-interactivas').forEach((text) => {
      for (let key of Object.keys(text)) {
        this.guiaText[key] = text[key];
      }
    });

    this.alertaModalService.confirmacion(
      this.guiaText['activar-guia'],
      this.guiaText['titulo'],
      () => {
        const driverObj = driver({
          showProgress: true,
          nextBtnText: this.guiaText['siguiente'],
          prevBtnText: this.guiaText['anterior'],
          doneBtnText: this.guiaText['finalizar'],
          steps: this.infoPantalla.value.pasos,
          onDestroyed: () => {
            // Cuando termine la guía
            if (onFinish) onFinish();
          }
        });
        driverObj.drive();
      },
      async () => {
        // Canceló la guía
        if (onFinish) onFinish();
        // Cerrar la alerta si aún está en la cola
        const alertasActivas = this.alertaModalService.colaAlertas.getValue();
        if (alertasActivas.length > 0) {
          this.alertaModalService.colaAlertas.next(
            alertasActivas.filter((_, index) => index !== 0)
          );
        }
      }
    );
  }


  setCookie(nombreCookie: string, valorCookie: string) {
    this.cookieService.set(nombreCookie, valorCookie);
  }

  getCookie(nombreCookie: string) {
    return this.cookieService.get(nombreCookie);
  }

  deleteCookie(nombreCookie: string) {
    this.cookieService.delete(nombreCookie);
  }

  getFooterInfo(): Observable<FooterInfoResponseDTO> {
    return this.http.get<FooterInfoResponseDTO>(
      `${this.apiUrl}/util/footer-info`
    ).pipe(
        timeout(5000),
      catchError((error) => {
          if (error.name === 'TimeoutError') {
            console.log('La solicitud ha excedido el tiempo de espera.');
          }
          return throwError(() => error); // Reenvía el error
      }));
  }

  private roleSubject = new BehaviorSubject<string | null>(null);
  public role$ = this.roleSubject.asObservable();

  setRole(role: string | null) {
    this.roleSubject.next(role);
  }
  getRole(): string | null {
    return this.roleSubject.value;
  }

  logout(idUsuario: number): Observable<any> {
    return this.http.get(`${this.apiUrl}/autenticacion/logout/${idUsuario}`);
  }

  notifyRoleChange(): void {
    const dataRol = sessionStorage.getItem('user_type');
    if (dataRol) {
      const userType = JSON.parse(dataRol);
      this.roleSubject.next(userType.Nombre);
    }
  }
}
